import {connectToStores} from 'epic-alt-utils';
import Error404 from 'epic-fortnite-react/components/error/Error404';
import PropTypes from 'prop-types';
import React from 'react';

import Chapter2Actions from '../../actions/Chapter2Actions';
import CtaFooter from '../../components/chapter2/CtaFooterC2s2';
import Screens from '../../components/chapter2/Screens';
import VideoHeader from '../../components/chapter2/VideoHeaderC2s2';
import MetaTags from '../../components/common/MetaTags';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import {Chapter2Store, HeaderStore} from '../../stores';

@connectToStores
class Chapter2s2View extends React.Component {
  static propTypes = {
    chapter2Store: PropTypes.object,
    loginStore: PropTypes.object,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool,
  };

  static getStores() {
    return [Chapter2Store];
  }

  static getPropsFromStores() {
    return {
      chapter2Store: Chapter2Store.getState(),
      mobile: HeaderStore.getState().mobile(),
      tablet: HeaderStore.getState().tablet(),
    };
  }

  static getInitialActions() {
    return [
      () => {
        Chapter2Actions.getChapter2s2();
      },
    ];
  }

  render() {
    const {chapter2Store, mobile} = this.props;

    if (chapter2Store.loading) {
      return <LoadScreen show={true} />;
    }

    if (!chapter2Store || !chapter2Store.chapter2s2Data) {
      return <Error404 />;
    }

    const {
      chapter2s2Data: {meta, videoHeader, screens, footerCta},
    } = chapter2Store;

    return (
      <div className="chapter2s2">
        <MetaTags meta={meta} />
        <VideoHeader data={videoHeader} />
        <Screens data={screens} />
        <CtaFooter sectionClassName="left-section" data={footerCta} mobile={mobile} />
      </div>
    );
  }
}

export default Chapter2s2View;
